import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./StockProductos.css";

function StockProductos() {
  const origenComponente = "StockProductos";
  const { ecv_u, cv_u, usuarioSesion, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);

  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    v_formulario: false,
    v_modal: false,
    i_procesandoApiCarga: true,
    do_datosTabla: {},
    do_filtros: {},
    do_seleccionados: {},
    da_distribuidores: [],
    d_usuario: "",
    d_editarVarios: false,
    d_eliminarVarios: false,
    d_agregarPT: false,

    d_incrementarStock: false,
    d_reemplazarStock: false,
  });

  useEffect(() => {
    console.log("usuario en sesion", usuarioSesion);
    const stockProductosCrud = _api_.f_estructuraStockProductoTerminado({
      parametros: {
        // codUsuario: usuarioSesion,
        incrementoActualizacion: v_u.d_incrementarStock ? 1 : v_u.d_reemplazarStock ? 2 : 0,
      },
      origen: origenComponente,
      timeout: 5000,
    });
    stockProductosCrud.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        // dPC.contenido.headgrid.push({
        //   tipo: "control",
        //   visible: true,
        //   valor: "Opciones",
        // });
        // for (let temp of dPC.contenido.headgrid) {
        //   temp["funcionesEndpoint"] = { change: "obtenerInfoUsuario" };
        //   temp["variableRegistro"] = "codigo";
        // }
        console.log(dPC.contenido);
        _f_.asignar(ev_u, { do_datosTabla: dPC.contenido });
      }
      _f_.asignar(ev_u, { i_procesandoApiCarga: false });
    });
  }, [v_u.d_incrementarStock, v_u.d_reemplazarStock]);

  if (v_u.i_procesandoApiCarga) return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;

  //if (cv_u.error) return <div>error</div>;

  return (
    <div className="stockProductoscss-contenedor">
      {v_u.v_modal && (
        <ModalInformacion
          fCerrar={() => {
            _f_.asignar(ev_u, {
              v_modal: false,
              v_formulario: false,
            });
          }}>
          <_form_.Formulario></_form_.Formulario>
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Stock de Productos"}</div>
      <div className={"stockProductoscss-botones"} style={{ padding: "0.3rem", width: "100%", display: "flex" }}>
        <_ipt_.Input4
          tipo="date"
          defaultValue={_f_.fechaActual({ formato: "yyyy-mm-dd" })}
          texto="Fecha Actual"
          disabled
        />
        {!v_u.d_reemplazarStock && !v_u.d_incrementarStock && ["SADM01"].includes(rolUsuarioSesion) && (
          <_btn_.Boton
            texto="Reemplazar Stock"
            tipo="btn-2"
            estilos={{
              color: "var(--color_amarillo_1)",
              colorFuente: "var(--color_negro_1)",
              anchoB2: "10rem",
              colorFuenteB2: "black",
            }}
            onClick={() => {
              _f_.asignar(ev_u, { d_incrementarStock: false, d_reemplazarStock: true });
              // Object.keys(filtrosvalores).map((clave) => {
              //   _f_.asignar(efiltrosvalores, { [clave]: "" });
              // });
            }}
          />
        )}
        {!v_u.d_reemplazarStock && !v_u.d_incrementarStock && (
          <_btn_.Boton
            texto="Incrementar Stock"
            tipo="btn-2"
            estilos={{
              color: "var(--color_amarillo_1)",
              colorFuente: "var(--color_negro_1)",
              anchoB2: "10rem",
              colorFuenteB2: "black",
            }}
            onClick={() => {
              _f_.asignar(ev_u, { d_incrementarStock: true, d_reemplazarStock: false });
              // Object.keys(filtrosvalores).map((clave) => {
              //   _f_.asignar(efiltrosvalores, { [clave]: "" });
              // });
            }}
          />
        )}
      </div>
      {
        <Filtros
          filtros={v_u.do_datosTabla.filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtros: valores });
          }}
        />
      }

      <div className="stockProductoscss-cuerpo">
        <_tabla_.Tabla
          origenComponente={origenComponente}
          modoVista={"modo2"}
          cabecera={v_u.do_datosTabla.headgrid}
          registros={v_u.do_datosTabla.grid}
          filtros={v_u.do_filtros}
          datosComplementarios={{ codDistribuidor: v_u.d_usuario, productosSeleccionados: v_u.do_seleccionados }}
          permiteVerCategoriaCompleta={true}
          permiteMultiseleccion={false}
          permiteOpciones={true}
          camposCodigosSeleccion={["codigo"]}
          campoCodigoCategoria={"categoria"}
          reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
          permiteDespliegueInferiorPorRegistro={false}
          permiteDespliegueModalPorRegistro={false}
          permiteDetalleAlTocarElemento={true}
          // mapaDeComponentes={{
          //   MEliminarProductoTerminado,
          //   MDetalleInferiorProductoTerminado,
          //   MAgregarEditarProductoTerminado,
          // }}
          fObtenerSeleccionados={(seleccionados) => {
            _f_.asignar(ev_u, { do_seleccionados: seleccionados });
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
              erecargaComponente((prev) => !prev);
            }
          }}
        />
      </div>

      {(v_u.d_reemplazarStock || v_u.d_incrementarStock) && (
        <div className="stockProductoscss-opciones">
          <_btn_.Boton
            texto="Guardar Stock"
            tipo="btn-2"
            estilos={{ color: "#4e942e", anchoB2: "10rem" }}
            procesando={v_u.v_formulario}
            onClick={() => {
              const guardarStockAPI = _api_.f_guardarStock({
                parametros: {},
                origen: origenComponente,
                timeout: 20000,
              });
              guardarStockAPI.respuesta.then((dPC) => {
                _f_.asignar(ecv_u, dPC, true, origenComponente);
                console.log(dPC);
                if (!dPC.error) {
                  _f_.asignar(ev_u, { d_incrementarStock: false, d_reemplazarStock: false });
                }
              });
            }}
          />
        </div>
      )}
    </div>
  );
}
export default StockProductos;
